/**
 * @file  audit/audit.model.ts
 * @description  site audit information
 *
 * @author ogarcia (ozkary)
 *
 */

import { BaseCustomer } from '../customer/customer.model';
import Entity from '../models/entity.model';
import { Vehicle } from '../vehicle/vehicle.model';

/**
 * app audit status to track the activity
 */
export enum AuditStatus {
  visit = 'visit',
  timeout = 'timeout',
  abandon = 'abandon',
  complete = 'receipt'
}

/**
 * audit information
 */
export interface Audit extends Entity {
  customer?: BaseCustomer;
  vehicle?: Vehicle;
  status: string;
  pageView: string[];
  refId?: string;
  domain: string;
  edition: string;
  token?: string;
}
